import util from '../../../../../share/util/utils';
import diagnoseResource from '../../../../../share/util/diagnose';
import { PHASE } from './constants';
import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';

/** 
 * 一覧表示画面 TableColumns作成 
 * @param {object} self this インスタンス
 */
export function createColumns(self) {
  self.tableColumns = [
    { name: 'status', label: 'message.header_vehicle_dtc_table_status', originalSortFunc: sortStatus, },
    { name: 'occurrence_date', label: 'individual.label_dtc_es_specific_occurrence_time', originalSortFunc: sortFdDataItems },
    { name: 'fd', label: 'individual.header_vehicle_system_table_details_fd', useButton: true, originalSortFunc: diagnoseResource.sortFuncFfd, }
  ];
}

/** 一覧表示画面 他項目(ステータス・詳細FD以外)のソート処理 
 * @param {Object} param ソート情報(data, sortDir, sortKey)
 */
function sortFdDataItems(param) {
  if (!param.data) {
    return null;
  }
  // 結果リスト
  let itemList = [];
  const hyphenList = [];
  param.data.forEach(element => {
    if (element[param.sortKey] !== '-') {
      itemList.push(element);
    }
    else {
      hyphenList.push(element);
    }
  });
  // 昇順・降順に関わらず、ハイフン表示は最下行に表示する
  itemList = util.sortItems(itemList, param.sortKey, param.sortDir);
  itemList = itemList.concat(hyphenList);
  return itemList;
}

/** 
 * 一覧表示画面 表示データ作成 
 * @param {object} self this インスタンス
 */
export function createDisplayData(self) {
  const setArr = [];
  let isData = false;

  self.preFdData.forEach((obj) => {
    const setObj = {};
    setObj.status = self.$t(`${self.i18nWsKey}.${obj.status}`);
    setObj.unique_status = obj.status;
    // FD一覧に表示する発生日時を取得するため、FDのDID変換後の値を表示用の値で返す処理を行う関数を呼び出す。日時の為、i18nDidKeyとハイフンフラグは指定しない
    setObj.occurrence_date = individualWorkSupportUtil.getDisplayFdData(self, '', { data_type: obj.occurrence_date_data_type, value: obj.occurrence_date });
    setObj.buttonVisible = obj.has_fd;
    // ステータスソート用のNo付与
    setObj.no = obj.no;

    // has_fdがtrueのものが存在しない限り、データ無しフラグを更新し続ける
    if (!isData) {
      isData = obj.has_fd;
    }

    setArr.push(setObj);
  });
  if (isData) {
    // 表示データが存在する場合は一覧表示遷移
    self.phase = PHASE.LIST_VIEW;
    setTimeout(() => {
      self.wallDisplayInfo = setArr;
    });
  } else {
    // 表示データが存在しない場合は履歴なし表示遷移
    self.phase = PHASE.NODATA;
  }
}

/** 一覧表示画面 ステータス項目のソート処理 
 * @param {Object} param ソート情報(data, sortDir, sortKey)
 */
function sortStatus(param) {
  if (!param.data) {
    return null;
  }
  let itemList = [];
  // 別途付与したno項目(画面非表示)でソートする
  itemList = util.sortItems(param.data, 'no', param.sortDir);
  return itemList;
}

/**
 * 詳細FD表示画面 TableColumns作成
 * @param {object} self this インスタンス
 * @param {string} target_status 選択したステータス
 */
export function createFdColumns(self, target_status) {
  // 項目・単位は固定で設定
  self.tableFdColumns = [
    { name: 'item', label: 'message.header_vehice_ffd_item' },
    { name: 'unit', label: 'message.header_vehice_ffd_unit' }
  ];

  // 初回のオブジェクトを取得(ステータス一致且つデータが入っていることが条件)
  const statData = self.preDetailFdData.find((element) => element.status === target_status);
  const obj = statData.detail_fd_data_list.find((element) => element);
  // read_dataの件数分、'n回'表示のカラムを追加する
  const cntMessage = self.$t('individual.header_vehicle_system_table_cnt');
  for (let i = 0; i < obj.read_data.length; i++) {
    self.tableFdColumns.push({ name: 'count_' + i, label: util.setColums((i + 1), cntMessage, '{0}{1}'), useHtmlBind: true });
  }
}

/**
 * 詳細FD表示画面 表示データ作成
 * @param {object} self this インスタンス
 * @param {string} target_status 選択したステータス
 */
export function createDisplayFdData(self, target_status) {
  // 対象ステータスのデータを取得
  const statData = self.preDetailFdData.find((element) => element.status === target_status);
  const setArr = [];
  for (const element of statData.detail_fd_data_list) {
    const obj = {};
    // 画面に表示しないが、初期ソート用にDID値をセット
    obj['did'] = element.did;
    // 項目・単位をセット
    obj['item'] = self.$te(`${self.i18nSpwsDidKey}.${element.did}_1_all`) ? self.$t(`${self.i18nSpwsDidKey}.${element.did}_1_all`) : '';
    obj['unit'] = self.$t(`didUnit.${element.unit_id}`);

    // no でソート
    element.read_data.sort((a, b) => a.no > b.no ? 1 : -1);
    // data_typeがValueの項目(read_data先頭のdata_typeを見て判断)で、1項目の値が全て0の場合はハイフンを表示する
    const allHyphenFlg = element.read_data[0].data_type === 'Value' && element.read_data.every((obj) => Number(obj.value) === 0);
    // read_data をloopし、文言ファイルに一致するキーが存在する場合は対象の文言を、それ以外は値をそのままセット(HEXの場合は0xを付与)
    for (let i = 0; i < element.read_data.length; i++) {
      const keyName = 'count_' + i;
      obj[keyName] = individualWorkSupportUtil.getDisplayFdData(self, element.did, element.read_data[i], self.i18nSpwsDidKey, allHyphenFlg);
    }
    setArr.push(obj);
  }
  setTimeout(() => {
    self.displayFdInfo = setArr;
  });
}